module.exports = __webpack_public_path__ + "img/smile-face.feb3b2f0.png";